// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__P8Z96","colBig":"styles_colBig__2RHL8","colSmall":"styles_colSmall__2xqze"};